import React, { createContext, useContext, useState, useCallback, useMemo } from 'react'

interface DashboardTourState {
  isRunning: boolean
  isCompleted: boolean
}

interface DashboardTourContextType {
  tour: DashboardTourState
  setTourRunning: (isRunning: boolean) => void
}

const DashboardTourContext = createContext<DashboardTourContextType | undefined>(undefined)

export const DashboardTourProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [tour, setTour] = useState<DashboardTourState>({
    isRunning: false,
    isCompleted: false,
  })

  const setTourRunning = useCallback((isRunning: boolean) => {
    setTour(prev => ({ ...prev, isRunning, isCompleted: !isRunning }))
  }, [])

  const value: DashboardTourContextType = useMemo(
    () => ({
      tour,
      setTourRunning,
    }),
    [setTourRunning, tour]
  )

  return <DashboardTourContext.Provider value={value}>{children}</DashboardTourContext.Provider>
}

export const useDashboardTour = (): DashboardTourContextType => {
  const context = useContext(DashboardTourContext)
  if (context === undefined) {
    throw new Error('useDashboardTour must be used within a DashboardTourProvider')
  }
  return context
}
